import { booleanAttribute, ChangeDetectionStrategy, Component, input, OnInit, output, viewChild } from '@angular/core';
import { InputFieldSelectionBaseComponent } from './input-field-selection-base.component';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';

@Component({
  selector: 'mng-inputfield-select',
  imports: [
    MatFormField,
    ExtendedModule,
    MatLabel,
    MatSelect,
    MatSelectTrigger,
    ReactiveFormsModule,
    MatOption,
    MatError
  ],
  template: `
    <mat-form-field
      style="width: 100%;"
      [ngStyle]="ngStyle()"
      [appearance]="appearance()"
      [subscriptSizing]="subscriptSizing()"
      [floatLabel]="floatLabel()"
    >
      @if (field().label) {
        <mat-label>{{ field().label }}</mat-label>
      }
      <mat-select
        #select
        [id]="field().id"
        [formControl]="field().control"
        [multiple]="multiple()"
        [panelWidth]="panelWidth()"
        (selectionChange)="selectionChange.emit($event?.value)"
      >
        <mat-select-trigger>
          <span [innerHTML]="getSelectedLabel()"></span>
        </mat-select-trigger>
        @for (op of options(); track op.name) {
          <mat-option [value]="op.value" [class.small-option-text]="smallOptionText()">
            <div [innerHTML]="getRealOptionLabel(op)"></div>
          </mat-option>
        }
      </mat-select>
      @if (showError() && hasErrors) {
        <mat-error> {{ validationMessage }} </mat-error>
      }
    </mat-form-field>
  `,
  styles: `
    .small-option-text {
      font-size: small;
      min-height: 28px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldSelectComponent extends InputFieldSelectionBaseComponent implements OnInit {
  readonly select = viewChild<MatSelect>('select');
  readonly selectionChange = output<unknown>();
  readonly multiple = input(false, { transform: booleanAttribute });
  readonly panelWidth = input('');
  readonly smallOptionText = input(false, { transform: booleanAttribute });

  get matSelect(): MatSelect {
    return this.select();
  }
}
